import { render, staticRenderFns } from "./ModelNumber.vue?vue&type=template&id=176d80ad&scoped=true&"
import script from "./ModelNumber.vue?vue&type=script&lang=js&"
export * from "./ModelNumber.vue?vue&type=script&lang=js&"
import style0 from "./ModelNumber.vue?vue&type=style&index=0&id=176d80ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d80ad",
  null
  
)

export default component.exports